import React from 'react';
import {history} from "@umijs/max";
import "./index.less"

const PrivacyModal = ({filePath,title}) => {
    return (

    <a onClick={()=>history.push(`/Agreement?filePath=${filePath}`)}>
        {title}
    </a>
);
};

export default PrivacyModal;